/** Parse complete SSE `data:` frames from a growing buffer. */
export const parseSseFrames = (buffer) => {
  const blocks = buffer.split('\n\n');
  const remainder = blocks.pop() || '';
  const events = [];
  for (const block of blocks) {
    const line = block.split('\n').find((l) => l.startsWith('data:'));
    if (!line) continue;
    const jsonStr = line.replace(/^data:\s*/, '').trim();
    if (!jsonStr) continue;
    try {
      events.push(JSON.parse(jsonStr));
    } catch {
      /* incomplete frame */
    }
  }
  return { events, remainder };
};
